import { getRequest, severityCode } from "./httpClient";

const END_POINT = "chart/energy/distribution";

const getEnergyDistribution = async (partyReference, addressId, year, usagePerSquareMeter = true) => {
  const path = addressId ? `${END_POINT}/${partyReference}/${addressId}` : `${END_POINT}/${partyReference}`;
  return await getRequest(path, { year, usagePerSquareMeter });
};

export { getEnergyDistribution, severityCode };